import React from "react";
import { useNavigate } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import Logo from "./Logo";
import { contact } from "../mock";

const sectionLinks = [
  { label: "Home", type: "section", id: "home" },
  { label: "Services", type: "section", id: "services" },
  { label: "For Schools", type: "section", id: "schools" },
  { label: "Why Us", type: "section", id: "why" },
  { label: "Reviews", type: "section", id: "reviews" },
  { label: "Join as Counsellor", type: "section", id: "join" },
  { label: "Find a Counsellor", type: "route", to: "/counsellors" },
  { label: "Course Finder", type: "route", to: "/course-finder" },
  { label: "Universities", type: "route", to: "/universities" },
  { label: "Destinations", type: "route", to: "/destinations" },
  { label: "Saved", type: "route", to: "/saved" },
  { label: "Blog", type: "route", to: "/blog" },
  { label: "Free Assessment", type: "route", to: "/assessment" },
];

export default function Footer() {
  const navigate = useNavigate();
  const go = (l) => {
    if (l.type === "route") navigate(l.to);
    else navigate("/", { state: { scrollTo: l.id } });
  };
  return (
    <footer className="bg-[#0f1838] text-white/80">
      <div className="max-w-[1240px] mx-auto px-5 py-14 grid grid-cols-1 md:grid-cols-3 gap-10">
        <div>
          <div className="bg-white inline-flex px-3 py-2 rounded-lg">
            <Logo height={42} />
          </div>
          <p className="mt-5 text-sm leading-relaxed max-w-xs">
            Helping students and professionals make confident, informed decisions about education and careers.
          </p>
        </div>

        <div>
          <h4 className="font-head font-semibold text-white mb-4">Quick Links</h4>
          <ul className="space-y-2.5 text-sm">
            {sectionLinks.map((l) => (
              <li key={l.label}>
                <button onClick={() => go(l)} className="hover:text-[#F58220] transition-colors">{l.label}</button>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="font-head font-semibold text-white mb-4">Get in Touch</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-3"><Phone size={16} className="text-[#F58220]" /> {contact.phone}</li>
            <li className="flex items-center gap-3"><Mail size={16} className="text-[#F58220]" /> <span className="break-all">{contact.email}</span></li>
            <li className="flex items-center gap-3"><MapPin size={16} className="text-[#F58220]" /> India</li>
          </ul>
          <a href={contact.instagram} target="_blank" rel="noopener noreferrer"
            className="mt-5 inline-flex items-center justify-center w-10 h-10 rounded-lg bg-white/10 hover:bg-[#F58220] transition-colors text-white">
            <Instagram size={18} />
          </a>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="max-w-[1240px] mx-auto px-5 py-5 text-sm text-white/50 flex flex-col sm:flex-row items-center justify-between gap-2">
          <span>&copy; {new Date().getFullYear()} The Career Counsellor. All rights reserved.</span>
          <button onClick={() => navigate("/admin/login")} className="text-white/30 hover:text-white/60 transition-colors text-xs">Admin</button>
        </div>
      </div>
    </footer>
  );
}
